import SettingMyProfile from "components/Profiles/SettingMyProfile";
import NotFooterLayout from "layouts/NotFooterLayout";
import React from "react";

const SettingMyProfilePage = () => {
  return (
    <>
      <NotFooterLayout namePage="โปรไฟล์ของฉัน">
        <div className="layout-content">
            <SettingMyProfile />
        </div>
      </NotFooterLayout>
    </>
  );
};

export default SettingMyProfilePage;
